export class AudioContainer {
    audio: Phaser.Sound

    constructor(audio: Phaser.Sound) {
        this.audio = audio
    }

}

export class Audio {
    // TODO: If you are nesting Audio.add calls, i.e. calling one in the onStop of another, the subsequent calls need to have stopAllAudio = false.
    //  We should fix this.

    static add = (
        game: Phaser.Game, asset: string, {volume = 1, onStop, onPlay, play = true, stopAllAudio = true}:
            {volume?: number, onStop?: () => void, onPlay?: () => void, play?: boolean, stopAllAudio?: boolean} = {}
    ): AudioContainer => {
        if (stopAllAudio) {
            game.sound.stopAll()
        }

        const audio = game.add.audio(asset)

        audio.volume = volume

        if (onStop) {
            audio.onStop.addOnce(onStop)
        }

        if (onPlay) {
            audio.onPlay.addOnce(onPlay)
        }

        if (play) {
            audio.play()
        }

        return new AudioContainer(audio)
    }
}
